import { render, staticRenderFns } from "./lives.vue?vue&type=template&id=a5440c50&scoped=true"
import script from "./lives.vue?vue&type=script&lang=js"
export * from "./lives.vue?vue&type=script&lang=js"
import style0 from "./lives.vue?vue&type=style&index=0&id=a5440c50&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5440c50",
  null
  
)

export default component.exports